<script type="text/babel">
  import Base from './BaseChart.vue'

  export default Base.extend({
    name: "BaseMultidimentionalChart",
    methods: {
      buildDataset: function () {
        var datasets = []

        // Get first element for reference, this will be used to extract datasets name
        var reference = this.data[Object.keys(this.data)[0]]

        // We now have to iterate the keys of the first element to configure the datasets, we are using a counter to
        // track the index
        var counter = 0
        for (var propertyName in reference) {

          var color = this.getColor(counter)

          // Extract the data for the current dataset
          var data = []

          for (var keyName in this.data) {
            var item = this.data[keyName]
            data.push(item[propertyName])
          }

          // Push a standard configuration
          datasets.push({
            label: propertyName,
            backgroundColor: Chart.helpers.color(color).alpha(0.5).rgbString(),
            borderColor: color,
            fill: false,
            data: data,
          })

          counter++;
        }

        return {
          labels: Object.keys(this.data),
          datasets: datasets
        }
      }
    }
  })
</script>



// WEBPACK FOOTER //
// BaseMultidimentionalChart.vue?2666603a